<template>
  <div>
    <span v-html="$t('compCarbonFormsTravelsFormatsHavasHelp.info-1')"></span>
    <br /><br />
    <div class="has-text-centered">
      <img
        src="@/components/carbon/forms/travels/formats/havas/openOffice.png"
        width="800"
      />
    </div>
    <br />
    <span v-html="$t('compCarbonFormsTravelsFormatsHavasHelp.info-2')"></span>
    <br />
    <br />
    <ul style="list-style-type: square; margin-left: 25px">
      <li v-html="$t('compCarbonFormsTravelsFormatsHavasHelp.info-3')"></li>
      <li>
        <span v-html="$t('compCarbonFormsTravelsFormatsHavasHelp.info-4')" />
        {{ TRANSPORTATIONS.map((value) => $t(value)) }} ;
      </li>
      <li v-html="$t('compCarbonFormsTravelsFormatsHavasHelp.info-5')"></li>
      <li v-html="$t('compCarbonFormsTravelsFormatsHavasHelp.info-6')"></li>
      <li v-html="$t('compCarbonFormsTravelsFormatsHavasHelp.info-7')"></li>
      <li v-html="$t('compCarbonFormsTravelsFormatsHavasHelp.info-8')"></li>
      <li v-html="$t('compCarbonFormsTravelsFormatsHavasHelp.info-9')"></li>
    </ul>
  </div>
</template>

<script>
import Travel from '@/models/carbon/Travel.js'

export default {
  name: 'Help',
  computed: {
    TRANSPORTATIONS: function () {
      return Travel.transportations
    }
  }
}
</script>
